import { takeLatest, put, call, select } from 'redux-saga/effects';
import { BOOKING_ACTION_SAGA } from "../sagaTypes";
import { loadingAction } from '../actions.js';
import { url } from "../../config";
import growl from "../../lib/growl/growl.js";
import { getBookingSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/booking_action`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerBookingAction(args) {
    const user = yield select(state => state.user);
    const est = yield select(state => state.est);

    yield put(loadingAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('user_hash', user.hash);
        formData.append('booking_id', args.data?.booking_id);

        if (est.slug && est.id) {
            formData.append('slug', est.slug);
            formData.append('est', est.id);
        }

        const response = yield call (request, formData);

        if (response.success) {
            yield put(getBookingSagaAction());
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loadingAction(false));
    }
    finally {
        yield put(loadingAction(false));
    }
}

export default function* watcherBookingAction() {
    yield takeLatest(BOOKING_ACTION_SAGA, workerBookingAction);
}